module.exports = __webpack_public_path__ + "img/dxf.1d4274e6.png";